import { createAsyncThunk } from '@reduxjs/toolkit';
import _ from 'lodash';

import { APIClient } from '../../helpers/api_helper';
import * as ToastHelper from '../../helpers/toast_helper';

const prefix = 'company';
const tname = '公司';

export const getCompany = createAsyncThunk(`${prefix}/get-company`, async function () {
    const { data } = await APIClient.get(`/companies`);
    return data;
});